<template>
<LoginLayout>

	<h2>Connexion</h2>
	<el-form ref="loginForm" :model="loginForm" :rules="rules">
		
		<el-form-item prop="username">
			<el-input v-model="loginForm.username" prefix-icon="fas fa-at" placeholder="E-mail" @keyup.enter.native="onEnter"></el-input>
		</el-form-item>

		<el-form-item prop="password">
			<el-input v-model="loginForm.password" show-password prefix-icon="fas fa-key" placeholder="Mot de passe" @keyup.enter.native="onEnter"></el-input>
		</el-form-item>

		<el-button @click="submitLogin" type="primary" class="login-button" :disabled="authenticating">Se connecter</el-button>
	</el-form>
	<el-alert v-if="authenticationErrorCode === 401" title="Vos identifiants sont erronés" type="error" show-icon></el-alert>
	<el-alert v-if="authenticationErrorCode === 403" title="Ce compte est invalide" type="error" show-icon></el-alert>
	
</LoginLayout>
</template>

<script>
import LoginLayout from '@/layouts/login.layout.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'Login',
	components: { LoginLayout },
	data() {
		return {
			loginForm: {
				username: '',
				password: ''
			},
        	rules: {
				username: [ 
					{ required: true, message: 'Veuillez saisir votre adresse e-mail', trigger: 'blur' },
					{ type: 'email', message: 'Veuillez entrer une adresse e-mail valide', trigger: ['blur'] }
				],
				password: [ { required: true, message: 'Veuillez saisir votre mot de passe', trigger: 'blur' } ]
			}
		}
	},
	computed: {
		authenticating() {
			return this.$store.state.auth.authenticating
		},
		authenticationError() {
			return this.$store.state.auth.authenticationError
		},
		authenticationErrorCode() {
			return this.$store.state.auth.authenticationErrorCode
		}
	},
	methods: {
		login(credentials) {
			this.$store.dispatch('auth/login', credentials)
		},
		submitLogin() {

			// Valide le formulaire
			this.$refs['loginForm'].validate((valid) => {
				if (valid) {

					this.login({username: this.loginForm.username, password: this.loginForm.password})
					this.loginForm.password = ''
					
				} else {
					return false;
				}
			});
		},
		onEnter() {
			if (!!this.loginForm.username && !!this.loginForm.password) {
				this.submitLogin()
			}
		}
	}
};
</script>

<style>
.login-button {
	width: 100%;
}

.el-alert {
	margin-top: 10px;
}

</style>